import React from "react";
import CustomInput from "../../../../../../../Components/CustomInputs/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";

const DisabilityTimeOfClaimField: React.FC = () => {
   const dispatch = useDispatch();

   const TimeOfClaimValueDisability = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 4
         )?.timeOfClaim
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   return (
      <CustomInput
         labelText="Čas škody"
         name="TimeOfClaim"
         value={TimeOfClaimValueDisability || ""}
         onChange={(e) => {
            dispatch(
               updateFirstStepDynamicFields({
                  value: e.target.value,
                  field: "timeOfClaim",
                  typeOfClaimEnum: 4,
               })
            );
         }}
         validationText={handleShowErrorMessage(
            "disability.TimeOfClaim",
            claimFieldErrorsMessages
         )}
         placeholderText=""
         dependencyValue={shouldRenderSpecField(
            "disability",
            "TimeOfClaim",
            visibilityMatrixes
         )}
      />
   );
};

export default DisabilityTimeOfClaimField;
